import React, { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { EnquiryContext } from "./enquiry-context";
import Header from "./components/Header";
import Marquee from "./components/Marquee";
import EnquiryModal from "./components/EnquiryModal";
import FloatingActions from "./components/FloatingActions";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Process from "./sections/Process";
import Machinery from "./sections/Machinery";
import ShowcaseBand from "./sections/ShowcaseBand";
import Products from "./sections/Products";
import WhyUs from "./sections/WhyUs";
import Industries from "./sections/Industries";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAF8F3] text-stone-600 p-8 text-center">
          <div>
            <p className="font-display text-3xl font-bold uppercase text-stone-900">SK Engineering Works</p>
            <p className="mt-3 text-stone-500">Something went wrong. Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  const [modalProduct, setModalProduct] = useState(null);
  const openEnquiry = useCallback((product) => setModalProduct(product || "General Enquiry"), []);
  const closeEnquiry = useCallback(() => setModalProduct(null), []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <EnquiryContext.Provider value={{ openEnquiry, closeEnquiry, modalProduct }}>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Process />
        <Machinery />
        <ShowcaseBand />
        <Products />
        <WhyUs />
        <Industries />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
      <EnquiryModal open={modalProduct !== null} product={modalProduct} onClose={closeEnquiry} />
      <Toaster theme="light" position="top-center" richColors closeButton />
    </EnquiryContext.Provider>
  );
}

function App() {
  return (
    <div className="App bg-[#FAF8F3] min-h-screen">
      <ErrorBoundary>
        <BrowserRouter>
          <Site />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
